<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-file-lines"></i></div>
      <div>
        Bulletin
        <div class="page-title-subheading">Bulletins de l'établissement</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <select class="form-select form-select-sm" (change)="loadCompositions1($event)" >
            <option selected disabled></option>
            <option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <select class="form-select form-select-sm" [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-4">
        <label for="" class="form-label mb-0">Choisir un apprenant</label>
        <select class="form-select form-select-sm" name="search_text" [(ngModel)]="search_text" >
            <option selected disabled></option>
            <option *ngFor="let sac of students" [value]="sac?.student?.lastname">{{sac?.student?.lastname}} {{sac?.student?.firstname}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="container" *ngIf="search_text!=''">
    <div class="card mb-3" *ngFor="let d of data  | sampleSearch:search_text:'bulletins' ; let i=index">
        <div class="">
            <ul>
                <li><strong>Nom: </strong>{{d.lastname}}</li>
                <li><strong>Prénoms: </strong>{{d.firstname}}</li>
                <li><strong>Classe: </strong>{{d.classroom}}</li>
            </ul>
        </div>   
        <hr>
        <div class="card-body">
            <p>{{data!.length}} élément(s)</p>
            <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered">
                <thead>
                    <tr>
                        <th rowspan="2">Matière</th>
                        <th colspan="4">Moyenne</th>
                        <th rowspan="4">Appréciation</th>

                    </tr>
                    <tr>
                        <th>Elève</th>
                        <th>Classe</th>
                        <th>-</th>
                        <th>+</th>

                    </tr>
                   
                </thead>
                <tbody>
                    <tr *ngFor="let dt of d?.details ; let i=index">

                        <td >
                            <strong>{{dt.course}}</strong><br>
                            <small>{{dt.professor}}</small>
                        </td>
                        <td >
                            {{dt.stu_average}}
                        </td>
                        <td >
                            {{dt.class_average}}
                        </td>
                        <td >
                            {{dt.low_average}}
                        </td>
                        <td >
                            {{dt.high_average}}
                        </td>
                       
                        <td >
                            <p>{{dt.appreciation}}</p>
                        </td>
                        
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    </div>
</div>